import api from "./api";

export const getOTP = async (data) => {
    const response = await api.post(`/admin/forgot-password`, data)
    return response.data
}

export const verifyOTP = async (data) => {
    const response = await api.post(`/admin/verify-otp`, data)
    return response.data
}

export const changePassword = async (data) => {
    const response = await api.post(`/admin/reset-password`, data)
    return response.data
}